module.exports = __webpack_public_path__ + "assets/img/gpt1-1.fd069c5b.png";